import styled from 'styled-components';

export const StyledDiscountError = styled.div`
  margin-top: 8px;
  font-size: 12px;
  line-height: 16px;
  color: #d0021b;
`;
